import React, { useEffect } from "react";
import useGoToPricing from "../../hooks/useGoToPricing";
import { isLoggedIn } from "../../utils/isLoggedIn";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { Page, HomepageGlobalStyles } from "../Homepage/styles";
import CmsPage from "./CmsPage";
import { CmsGlow, CmsShell } from "./Cms.styles";

/**
 * Lovable CMS shell + Homepage Header/Footer.
 * List/filter/delete behavior stays production (see CmsPage).
 */
const Cms = () => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page>
      <HomepageGlobalStyles />
      <CmsShell>
        <CmsGlow aria-hidden="true" />
        <Header onSubscribeClick={goToPricing} hideSpacer />
        <CmsPage />
        <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
      </CmsShell>
    </Page>
  );
};

export default Cms;
